import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="hidden lg:block relative bg-brand-ink">
        <img src="https://static.prod-images.emergentagent.com/jobs/ed49e838-1e27-46cf-bdb6-4b21a3c4fa9e/images/798411f50a43f8c0117e7ab63666a813cd26d2e54438cf23eb4641bdd719fddf.jpeg" alt="Paws N Poses" className="w-full h-full object-cover opacity-80" />
        <div className="absolute bottom-12 left-12 text-white">
          <div className="font-display text-3xl tracking-[0.15em]">PAWS <span className="text-brand-red">N</span> POSES</div>
          <p className="mt-2 font-serif text-xl text-white/70">Owner dashboard</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-brand-ink/50 hover:text-brand-red transition-colors mb-10"><ArrowLeft className="w-4 h-4" /> Back to site</Link>
          <h1 className="font-display text-4xl">Welcome back</h1>
          <p className="mt-3 text-brand-ink/60">Sign in to manage your studio.</p>
          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-brand-ink/50 font-semibold">Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2 w-full rounded-xl border border-brand-line px-4 py-3 focus:ring-2 focus:ring-brand-red focus:outline-none" data-testid="login-email" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-brand-ink/50 font-semibold">Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2 w-full rounded-xl border border-brand-line px-4 py-3 focus:ring-2 focus:ring-brand-red focus:outline-none" data-testid="login-password" />
            </div>
            <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-brand-red text-white font-medium hover:bg-brand-reddark transition-colors disabled:opacity-60" data-testid="login-submit-btn">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Sign in
            </button>
          </form>
          <Link to="/forgot-password" className="mt-6 inline-block text-sm text-brand-ink/50 hover:text-brand-red transition-colors" data-testid="forgot-password-link">Forgot your password?</Link>
        </div>
      </div>
    </div>
  );
}
